import script from "./CheckPointCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckPointCard.vue?vue&type=script&setup=true&lang=js"

import "./CheckPointCard.vue?vue&type=style&index=0&id=e48c97f4&lang=scss"

const __exports__ = script;

export default __exports__